// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogPtBR = {
  "controls": {
    "boot": "Iniciar",
    "reset": "Reiniciar",
    "copyScreen": "Copiar Tela",
    "copyText": "Copiar texto",
    "pasteText": "Colar Texto",
    "saveState": "Salvar Estado",
    "restoreState": "Restaurar Estado",
    "toggleSound": "Alternar Som",
    "settings": "Configurações",
    "debugPanel": "Painel de Debug",
    "infoPanel": "Painel de informações",
    "reportIssue": "Relatar um problema",
    "privacyPolicy": "Política de privacidade"
  },
  "config": {
    "speed": "Velocidade",
    "display": "Configurações de Tela",
    "theme": "Tema",
    "openRetroControlPanel": "Painel de controle",
    "resetSettings": "Redefinir Configurações",
    "useOpenApple": "Usar a tecla {{modKey}} para Open Apple",
    "useShortcuts": "Usar a tecla {{modKey}} para atalhos de teclado",
    "useArrowKeys": "Usar Setas como Joystick",
    "scanlines": "Linhas de Varredura CRT",
    "ghosting": "Persistência do Fósforo",
    "crtDistortion": "Distorção CRT",
    "joystick": "Configuração de Joystick"
  },
  "machine": {
    "slotConfigurator": "Slots de expansão"
  },
  "speed": {
    "snail": "Velocidade Caracol (0.1 MHz)",
    "slow": "Lenta (0.5 MHz)",
    "normal": "Velocidade Normal (1 MHz)",
    "fast": "Rápida (4 MHz)",
    "warp": "Velocidade ridícula"
  },
  "colors": {
    "color": "Cor",
    "nofringe": "Cor (sem franja)",
    "green": "Verde",
    "amber": "Âmbar",
    "white": "Preto e Branco",
    "inverse": "Preto e Branco (inverso)"
  },
  "themes": {
    "classic": "Clássico",
    "dark": "Escuro",
    "minimal": "Minimalista"
  },
  "debug": {
    "helpPanel": "Mostrar painel de ajuda",
    "debugPanel": "Mostrar painel de debug",
    "expectinPanel": "Mostrar painel Apple exPectin",
    "helpTab": "Ajuda",
    "debugTab": "Depuração",
    "memory": "Memória",
    "stack": "Pilha",
    "state": "Estado da CPU",
    "registers": "Registros",
    "step": "Passo",
    "stepOver": "Pular",
    "stepInto": "Entrar",
    "stepOut": "Sair",
    "resume": "Retomar",
    "pause": "Pausar",
    "loadSymbolTable": "Carregar tabela de símbolos"
  },
  "tour": {
    "welcome": "Bem-vindo ao emulador Apple2TS!",
    "clickNext": "Para saber mais, pressione o botão Próximo.",
    "bootButton": "Clique aqui para iniciar o emulador.",
    "resetButton": "Clique aqui para reiniciar o Apple II e reinicializar ou entrar no BASIC.",
    "diskImages": "Escolha uma das imagens de disco instaladas.",
    "floppyDisks": "Ou clique em um dos ícones de disquete para carregar uma imagem de disco.",
    "saveRestore": "Você pode salvar e restaurar o estado completo do emulador usando estes botões.",
    "themeButton": "Clique aqui para mudar o tema da interface do emulador.",
    "endTour": "Você chegou ao final do tour. Clique no botão do tour do globo para experimentar um dos outros tours, ou pressione Finalizar para começar a usar o emulador.",
    "tourSelectorHint": "Clique no botão de tour do globo para experimentar um dos outros tours ou pressione Concluir para começar a usar o emulador.",
    "settingsWelcome": "Apple2TS tem um conjunto completo de controles para o emulador e o Apple II. Para saber mais, pressione o botão Próximo.",
    "mainControls": "Aqui, você pode inicializar e reiniciar o Apple II, restaurar e salvar o estado, copiar a tela, ou colar texto no emulador.",
    "snapshot": "A qualquer momento, você pode tirar um instantâneo do estado atual do emulador, então voltar no tempo para um estado anterior, ou avançar rapidamente novamente. Você também pode salvar o estado do emulador com todos os instantâneos atuais.",
    "pauseButton": "Você pode pausar o emulador a qualquer momento, congelando o processador 6502. Isso é útil para pausar a ação em um jogo, ou entrar no debugger.",
    "debugButton": "Clique no inseto para entrar no modo debug, onde você pode ver o estado interno do processador 6502. Clique novamente para voltar ao modo normal.",
    "configButtons": "A fileira inferior de botões controla o estado do Apple II, começando com a velocidade do emulador, a cor da tela, e silenciar o som.",
    "keyboardButtons": "Se a tecla caps lock estiver ligada, então todos os caracteres digitados são MAIÚSCULOS.",
    "altArrowKeys": "A próxima tecla determina se a tecla {{modKey}} é usada para atalhos de teclado ou a tecla Open Apple do Apple II. A tecla final determina se as teclas de seta podem ser usadas como o joystick do Apple II.",
    "clearCookies": "Apple2TS automaticamente salva as configurações atuais do emulador como cookies do navegador. Pressione este botão para redefinir essas configurações e excluir os cookies.",
    "debugWelcome": "Apple2TS tem um rico conjunto de ferramentas para analisar e debuggar código assembly 6502. Para saber mais, pressione o botão Próximo.",
    "debugIcon": "Clique no ícone do Inseto nas abas Info para visualizar o painel Debug.",
    "debugPause": "Pressione o botão Pausar para pausar ou retomar a execução do emulador.",
    "debugControls": "Agora que pausamos, podemos percorrer o código desassemblado usando os botões Passo Sobre, Dentro, e Fora. Também podemos pular rapidamente para o endereço atual do Program Counter (PC).",
    "debugDisassembly": "Aqui vemos o código desassemblado, com os endereços hexadecimais, a instrução de três letras, e quaisquer valores ou endereços. Se você mover o mouse sobre um valor verde, aparecerá uma dica com o valor atual. Clicar em um endereço azul rolará para aquele local. Você também pode clicar na margem esquerda para adicionar ou remover breakpoints.",
    "debugInfo": "No meio temos o Dump da Pilha e um Mapa de Memória. O Mapa de Memória atualiza em tempo real e mostra quais bancos de memória estão atualmente ativos.",
    "debugMemory": "A última seção exibe a memória do Apple II. Você pode usar a lista suspensa para examinar diferentes porções de memória. Se você mudar para uma das páginas HGR, você obterá uma visualização ampliada da tela de alta resolução, vinculada aos locais de memória. Você também pode pesquisar valores hexadecimais ou strings ASCII, e salvar a memória em um arquivo.",
    "back": "Voltar",
    "close": "Fechar",
    "last": "Finalizar",
    "next": "Próximo",
    "nextLabelWithProgress": "Próximo (Passo {step} de {steps})",
    "skip": "Fechar",
    "guidedTour": "Tour Guiado",
    "mainLabel": "Tour Guiado: Principal",
    "settingsLabel": "Tour Guiado: Configurações",
    "debugLabel": "Tour Guiado: Depuração"
  },
  "disk": {
    "hardDisk": "Disco Rígido",
    "eject": "Ejetar Disco",
    "insert": "Inserir Disco",
    "writeProtected": "Protegido contra Gravação",
    "readWrite": "Leitura/Gravação",
    "empty": "Vazio",
    "loading": "Carregando...",
    "selectDisk": "Selecionar Imagem de Disco",
    "browse": "Navegar",
    "newReleases": "Novos Lançamentos",
    "writeProtectDisk": "Proteção contra Gravação de Disco",
    "saveDiskToDevice": "Salvar Disco",
    "saveDiskTo": "Salvar Disco no",
    "saveDiskToMenu": "Salvar Disco no >",
    "addToFavorites": "Adicionar aos Favoritos",
    "downloadDisk": "Baixar Disco",
    "downloadWoz": "Baixar imagem de disco WOZ",
    "downloadAndEjectDisk": "Baixar e Ejetar Disco",
    "ejectDisk": "Ejetar Disco",
    "ejectAllDisks": "Ejetar todos os discos",
    "saveDiskToOneDrive": "Salvar Disco no OneDrive",
    "saveDiskToGoogleDrive": "Salvar Disco no Google Drive",
    "loadDisk": "Carregar disco",
    "loadAdditionalDisks": "Carregar disco adicional...",
    "loadDiskFrom": "Carregar Disco de",
    "loadDiskFromMenu": "Carregar Disco de >",
    "loadDiskFromDevice": "Carregar Disco",
    "loadDiskFromDeviceReadOnly": "Carregar Disco do Dispositivo (Somente Leitura)",
    "loadDiskFromDeviceReadWrite": "Carregar Disco do Dispositivo (Leitura/Gravação)",
    "loadDiskFromInternetArchive": "Carregar Disco do Internet Archive",
    "loadDiskFromOneDrive": "Carregar Disco do OneDrive",
    "loadDiskFromGoogleDrive": "Carregar Disco do Google Drive",
    "insertBlankDisk": "Inserir disco em branco",
    "syncEveryMinute": "Sincronizar a Cada Minuto",
    "syncEvery5Minutes": "Sincronizar a Cada 5 Minutos",
    "pauseSyncing": "Pausar Sincronização",
    "syncNow": "Sincronizar Agora",
    "modified": "modificado",
    "synced": "sincronizado",
    "diskImage": "Imagem de Disco",
    "diskDrivesAndDevices": "unidades de disco e dispositivos",
    "syncedAt": "Sincronizado {{date}}",
    "clickToLoadDiskImage": "Clique para carregar a(s) imagem(ns) do disco",
    "clickToRemoveFromDiskCollection": "Clique para remover da coleção de discos",
    "clickToAddToDiskCollection": "Clique para adicionar à coleção de discos",
    "byCreator": "por {{creator}}",
    "clickToViewDetails": "Clique para ver detalhes",
    "standbyDisks": "Discos em espera (Clique para trocar de disco)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "Emulador de Apple IIe em TypeScript",
    "credit": "(c) {{year}} Chris Torrence e os colaboradores do Apple2TS",
    "keyboardShortcuts": "Atalhos de Teclado",
    "shortcutsUnavailable": "Os atalhos do emulador com {{keyMod}} ficam indisponíveis enquanto essa tecla estiver atribuída à função Open Apple. Com Ctrl+0 a Ctrl+5, ainda é possível selecionar a velocidade do emulador.",
    "diskImages": "Imagens de disco:",
    "diskContainers": "Arquivos compactados:",
    "multiDiskNotice": "Troca de vários discos: Clique no selo de vários discos para abrir o menu de troca rápida. Arquivos com vários discos (.zip, .7z, .gz) são carregados automaticamente na lista de troca.",
    "urlParameters": "Parâmetros de URL Opcionais",
    "examples": "Exemplos",
    "mobileInstructions": "Plataformas móveis:",
    "tapScreen": "Toque na tela para mostrar o teclado.",
    "arrowKeys": "Pressione as teclas de seta, esc, ou tab para enviar essas teclas ao emulador.",
    "ctrlKey": "Para enviar um caractere de controle, pressione o botão ctrl uma vez. Em seguida, toque na tela para mostrar o teclado e pressione a tecla desejada. O botão ctrl será automaticamente liberado.",
    "ctrlLock": "Para enviar múltiplos caracteres de controle, pressione o botão ctrl duas vezes para travá-lo (indicado por um ponto verde). Em seguida, toque na tela para mostrar o teclado e pressione as teclas desejadas. Pressione o botão ctrl novamente para liberá-lo.",
    "appleKeys": "As teclas open apple e closed apple se comportam da mesma forma que a tecla ctrl.",
    "openAppleKey": "Open Apple: pressionar Alt/Option Esquerdo",
    "closedAppleKey": "Closed Apple: Alt/Option Direito",
    "joystickKeys": "Teclas Joystick: Teclado numérico 8/2/4/6 (7/9/1/3), 0/5, ./Enter",
    "onScreenKeyboard": "Para o teclado na tela, para CTRL ou ESC:\ntoque uma vez para ativar e depois a tecla desejada.",
    "urlParametersBody": "Para parâmetros de URL opcionais, anexe-os à URL após um ponto de interrogação (?) e separe vários parâmetros com um e comercial (&). Use # para especificar a imagem de disco. Consulte o diálogo do Construtor de Links para exemplos.",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay com debug",
      "totalReplayChoplifter": "Total Replay, carregar Choplifter, modo integrado",
      "a2Desktop": "A2DeskTop 2MG com velocidade rápida e cor",
      "embeddedBasic": "Programa Applesoft BASIC Integrado",
      "binaryHexAddress": "Arquivo Binário com Endereço Hex"
    },
    "resourceLinks": {
      "desktopApp": "Aplicação Desktop Apple2TS",
      "corsProxy": "Proxy CORS por Corsfix",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "Carregando...",
    "error": "Erro",
    "success": "Sucesso",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "on": "ligado",
    "off": "desligado",
    "confirmTheme": "Recarregar o emulador e aplicar este tema agora?",
    "confirmReset": "Redefinir todas as configurações para valores padrão?",
    "fileNotFound": "Arquivo não encontrado",
    "invalidFile": "Formato de arquivo inválido",
    "diskInserted": "Disco inserido",
    "diskEjected": "Disco ejetado"
  },
  "keyboard": {
    "space": "Espaço"
  },
  "audio": {
    "speaker": "Alto-falante",
    "midi": "MIDI",
    "configuration": "Configuração de Áudio",
    "mute": "Mudo",
    "waveform": "Forma de Onda"
  },
  "print": {
    "printer": "Impressora",
    "print": "Imprimir",
    "clear": "Limpar",
    "save": "Salvar Saída",
    "dumpScreen": "Imprimir tela atual na impressora",
    "dumpScreenInverse": "Imprimir tela atual (Inverso)",
    "sendToPrinter": "Enviar para a impressora",
    "tearOff": "Arrancar página e redefinir",
    "printedPage": "Página impressa",
    "printerConfig": "Configuração da impressora",
    "pageLength": "Comprimento da página",
    "pageLengthLetter": "11 polegadas (Carta)",
    "pageLengthA4": "11,7 polegadas (A4)",
    "pageLengthTwelve": "12 polegadas"
  },
  "device": {
    "machineConfiguration": "Configuração da Máquina",
    "midiDeviceSelect": "Seleção de Dispositivo MIDI",
    "serialPortSelect": "Seleção de Porta Serial",
    "mockingboardWaveform": "Forma de Onda Mockingboard"
  },
  "collection": {
    "showApple2TSCollection": "Mostrar Coleção Apple2TS",
    "showNewReleases": "Mostrar novos lançamentos",
    "showFavorites": "Mostrar favoritos",
    "chooseDiskImage": "Escolher imagem de disco",
    "diskCollection": "Coleção de discos",
    "clickToShowDetails": "Clique para mostrar detalhes de",
    "clickToLoadDisk": "Clique para carregar disco",
    "diskIsNewRelease": "O disco é um novo lançamento",
    "diskIsApple2TSCollection": "O disco faz parte da coleção Apple2TS",
    "diskIsInternetArchive": "O disco faz parte do Internet Archive",
    "clickToRemoveFromCollection": "Clique para remover da coleção de discos",
    "clickToAddToCollection": "Clique para adicionar à coleção de discos",
    "diskIsSyncedVia": "Disco sincronizado via",
    "loadDiskIntoDrive": "Carregar Disco na Unidade",
    "exportDisksToHdv": "Exportar discos para HDV",
    "export": "Exportar",
    "clickToRemoveFromSelected": "Clique para remover dos discos selecionados",
    "clickToAddToSelected": "Clique para adicionar aos discos selecionados",
    "reportExportIssue": "Reportar um problema de exportação"
  },
  "debugControls": {
    "goBackInTime": "Voltar no Tempo",
    "takeSnapshot": "Capturar Instantâneo",
    "goForwardInTime": "Avançar no Tempo",
    "saveStateWithSnapshots": "Salvar Estado com Instantâneos",
    "resume": "Retomar",
    "pause": "Pausar",
    "trace": "Rastrear",
    "tracing": "Rastreando",
    "downloadTraceLog": "Baixar registro de rastreamento"
  },
  "fullscreen": {
    "fullScreen": "Tela Cheia"
  },
  "internetArchive": {
    "searchPlaceholder": "Digite o nome de um software ou clique em uma das categorias acima",
    "go": "IR"
  },
  "basic": {
    "newProgram": "Novo programa",
    "runFromBeginning": "Executar do início",
    "break": "Interromper",
    "continueRunning": "Continuar executando",
    "stepProgram": "Executar programa passo a passo",
    "resumeOutput": "Retomar saída",
    "freezeOutput": "Congelar saída",
    "importProgram": "Importar programa...",
    "exportProgram": "Exportar programa...",
    "renumberProgram": "Renumerar programa",
    "rebuildProgram": "Reconstruir programa a partir da memória",
    "displaySettings": "Configurações de exibição",
    "autoLineNumbering": "Numeração automática de linhas",
    "capitalizeKeywords": "Palavras-chave em maiúsculas",
    "rebuildWarning": "Isso substituirá o programa atual por uma versão reconstruída a partir da memória do Apple II. Você perderá quaisquer alterações não salvas. Tem certeza?",
    "variable": "Variável",
    "value": "Valor"
  },
  "expectin": {
    "runScript": "Executar script",
    "stopScript": "Parar script"
  },
  "saveDisassembly": {
    "title": "Salvar Desmontagem",
    "startAddress": "Endereço inicial $",
    "endAddress": "Endereço final $",
    "includeLabels": "Incluir rótulos de símbolos",
    "separatorLines": "Linhas separadoras após JMP, RTS"
  },
  "gamepad": {
    "useArrowKeys": "Setas como Joystick",
    "siriusJoyport": "Modo Sirius Joyport"
  },
  "traceSettings": {
    "title": "Configurações de rastreamento",
    "settings": "Configurações"
  },
  "linkBuilder": {
    "startupOptionsTab": "Opções de inicialização",
    "speedNames": {
      "warp": "Ridícula"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192"
    },
    "slots": {
      "configure": "Configurar placas de slot",
      "slot": "Slot {{slot}}:",
      "cardNone": "Nenhuma (vazia)"
    },
    "additionalDiskDrives": "Unidades de disco adicionais",
    "slot6Drive1": "Slot 6 Unidade 1 (Disquete 1)",
    "slot6Drive2": "Slot 6 Unidade 2 (Disquete 2)",
    "slot7Drive1": "Slot 7 Unidade 1 (Disco rígido 1)",
    "slot7Drive2": "Slot 7 Unidade 2 (Disco rígido 2)",
    "slot2Drive1": "Slot 2 Unidade 1 (VERA SD)",
    "slot4Drive1": "Slot 4 Unidade 1 (VERA SD)",
    "addAdditionalDisk": "Adicionar disco adicional para troca",
    "removeDisk": "Remover este disco",
    "addAnotherDisk": "Adicionar outro disco",
    "diskPlaceholder": "Nome do arquivo do disco {num} (ex.: sideB.woz|Disco de cenário)"
  },
  "startup": {
    "welcome": "Bem-vindo ao Apple2TS",
    "subtitle": "Emulador TypeScript do Apple II",
    "copyright": "(c) {{year}} C.Torrence + colaboradores",
    "diskCollections": "Clique no ícone Coleção de discos\npara carregar um jogo integrado."
  },
  "retroControl": {
    "machine": "Máquina",
    "fullscreen": "Tela cheia",
    "diskCollection": "Discos",
    "diskDrives": "Unidades de disco",
    "display": "Tela",
    "monitorMode": "Modo do monitor",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "Som",
    "options": "Opções",
    "skin": "Aparência",
    "personalization": "Personalização",
    "text": "Texto",
    "background": "Plano de fundo",
    "border": "Borda",
    "iigsColor": {
      "black": "Preto",
      "red": "Vermelho",
      "darkBlue": "Azul-escuro",
      "purple": "Roxo",
      "darkGreen": "Verde-escuro",
      "darkGray": "Cinza-escuro",
      "mediumBlue": "Azul médio",
      "lightBlue": "Azul-claro",
      "brown": "Marrom",
      "orange": "Laranja",
      "lightGray": "Cinza-claro",
      "pink": "Rosa",
      "lightGreen": "Verde-claro",
      "yellow": "Amarelo",
      "aquamarine": "Água-marinha",
      "white": "Branco"
    },
    "keyboard": "Teclado",
    "joystick": "Joystick",
    "slots": "Slots",
    "devices": "Dispositivos",
    "printerPort": "Porta da impressora",
    "modemPort": "Porta do modem",
    "quit": "Sair",
    "apple2tsCollection": "Coleção Apple2TS",
    "newReleases": "Novos lançamentos",
    "favorites": "Favoritos",
    "exportDisksToHdv": "Exportar discos para HDV",
    "noDiskDrivesAvailable": "Nenhuma unidade de disco disponível",
    "select": "Selecionar",
    "open": "Abrir",
    "load": "Carregar",
    "go": "Ir",
    "save": "Salvar",
    "clipboard": "Área de transferência",
    "cancelEsc": "Cancelar:Esc",
    "color": "Cor",
    "systemSpeed": "Velocidade do sistema",
    "other": "Outros",
    "timeMachine": "Instantâneos",
    "ports": "Portas",
    "language": "Idioma",
    "retroTheme": "Retrô",
    "lowercaseInput": "Entrada em minúsculas",
    "openAppleKey": "Tecla Open Apple",
    "sortOrder": "Ordenar",
    "card": {
      "empty": "Vazio",
      "mockingboard": "Mockingboard"
    }
  }
}
